type BuildUrlForEpcsParams = {
  startUrl: string;
  towReason?: string;
  towDistance?: number; // Kept as number - this is correct
};

export const buildUrlForEpcs = ({ startUrl, towDistance = 0, towReason = "" }: BuildUrlForEpcsParams): string => {
  const baseUrl = String(startUrl);

  // Create an object of parameters to include, filtering out falsy values
  const params = {
    towReason,
    towDistance,
  };

  // Filter out falsy values and convert to search params
  const searchParams = Object.entries(params)
    .filter(([_, value]) => !!value)
    .map(([key, value]) => `${key}=${String(value)}`); // Convert to string for URL

  // Return URL with or without query string
  return searchParams.length > 0 ? `${baseUrl}?${searchParams.join("&")}` : baseUrl;
};